/** Custom event so SiteNavbar can read Lenis direction (avoids scrollY jitter). */
export const LENIS_SCROLL_EVENT = "sparkl:lenis-scroll";

export function emitLenisScroll(lenis) {
  window.dispatchEvent(
    new CustomEvent(LENIS_SCROLL_EVENT, {
      detail: {
        scroll: lenis.scroll,
        direction: lenis.direction,
        velocity: lenis.velocity,
      },
    }),
  );
}
